import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBatteryFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"battery-full, power"} maskId="square-filled-radius-0-stroke-1-IconBatteryFull"><path fillRule="evenodd" clipRule="evenodd" d="M1 5V19H20V16H23V8H20V5H1ZM20 9V15H22V9H20ZM5 9H6V15H5V9ZM11 15V9H10V15H11ZM15 9H16V15H15V9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBatteryFull;
